import { Component } from '@opten/compiler/metadata/component';
import { TheWall, theWall } from '@opten/the-wall';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';
import { isMobile } from '../../utilities/detection';


@Component({ className: 'js-the-wall', observe: true })
export class TheWallComponent {
	instance: TheWall;
	innerWidth: number;

	constructor(private element: HTMLElement) {
		const contentTheme = element.getAttribute('data-content-theme');
		const closeButtonClass = contentTheme + ' background-transparent icon_close'
		this.innerWidth = window.innerWidth;
		this.instance = theWall(
			element,
			{
				closeButtonClass: closeButtonClass,
				arrows: false,
				scrollOffset: 250,
				margin: {
					top: 0,
					bottom: 0,
				},				
				onContentLoading:() =>{
					if (isMobile()) {	
						this.instance.resizeHeight();
					}
				},
				onContentLoaded:() =>{
					const gallerySliderComponent = this.instance.expanderInner.querySelector<HTMLElement>('.js-gallery-slider');
					if (gallerySliderComponent && isMobile()) {	
						setTimeout(() => this.instance.resizeHeight(), 600);
					}
				}
			},
		);

		window.addEventListener('resize', () => {
			if(this.innerWidth != window.innerWidth){
				this.innerWidth = window.innerWidth;
				this.instance.hideExpander();
			}			
		});
		if(screen.orientation && screen.orientation != undefined){
			screen.orientation.addEventListener('change',() => this.instance.hideExpander());
		}
		else{
			window.addEventListener('orientationchange', () => this.instance.hideExpander());
		}

		
		this.element.addEventListener(
			'opened.merbag.modal-the-wall',
			() => addClass(this.element, 'c-the-wall--modal-open')
		);
		this.element.addEventListener(
			'closed.merbag.modal-the-wall',
			() => removeClass(this.element, 'c-the-wall--modal-open')
		);
	}
}
